export default __webpack_public_path__ + "static/media/bank_maskan.0b9c8c9f.png";